document.addEventListener("DOMContentLoaded", () => {
  const STORE_URLS = {
    "pedal-commander-btn": "https://throttleresponsecontroller.com/products/pedal-commander",
    "fn-tuned-btn": "https://throttleresponsecontroller.com/products/fn-tuned",
  };

  const allCards = document.querySelectorAll(".trc-product-card");
  const searchInput = document.getElementById("trc-main-col-detail-search");

  // --- 1. ARAMA FONKSİYONELLİĞİ ---
  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      const searchTerm = e.target.value.toLowerCase().trim();

      allCards.forEach((card) => {
        const titleElement = card.querySelector(".trc-product-title");
        const cardTitle = (titleElement?.dataset?.title || titleElement?.textContent || "").toLowerCase();

        if (cardTitle.includes(searchTerm)) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      });
    });
  }

  // --- 2. AKORDEON & KART KAPATMA FONKSİYONU ---
  const closeAllCards = () => {
    allCards.forEach((card) => {
      const selectBtns = card.querySelectorAll(".select-store-btn");
      selectBtns.forEach((btn) => (btn.style.display = "block"));

      const btnWrapper = card.querySelectorAll(".trc-main-col-detail .trc-dd__compat-card");
      btnWrapper.forEach((item) => (item.style.display = "none"));

      const targetWrapperBtns = card.querySelectorAll(".store-btn");
      targetWrapperBtns.forEach((item) => (item.style.display = "none"));

      // Kapanan kartların padding-top değerini varsayılana sıfırla
      const storeBtnsWrapper = card.querySelector(".store-btns-wrapper");
      if (storeBtnsWrapper) {
        storeBtnsWrapper.style.paddingTop = "";
      }
    });
  };

  // --- 3. KART İÇERİK & BUTON İŞLEMLERİ ---
  allCards.forEach((mainCard) => {
    const trcProductTitle = mainCard.querySelector(".trc-product-title");
    if (!trcProductTitle?.dataset.title) return;

    // Title ayrıştırma işlemi
    const [, targetText] = trcProductTitle.dataset.title.split(/\s+for\s+/i);
    if (!targetText) return;

    const [make, ...modelParts] = targetText.trim().split(" ");
    const model = modelParts.join(" ");
    const queryParams = new URLSearchParams({ make, model }).toString();

    // Mağaza butonlarının yönlendirme linklerini bağla
    const targetWrapperBtns = mainCard.querySelectorAll(".store-btn");
    targetWrapperBtns.forEach((btn) => {
      Object.keys(STORE_URLS).forEach((className) => {
        if (btn.classList.contains(className)) {
          btn.onclick = () => {
            window.location.href = `${STORE_URLS[className]}?${queryParams}`;
          };
        }
      });
    });

    // "Select Store" butonlarına tıklama olayı
    const selectStoreBtns = mainCard.querySelectorAll(".select-store-btn");
    selectStoreBtns.forEach((btn) => {
      btn.style.pointerEvents = "auto";

      btn.addEventListener("click", (e) => {
        const clickedBtn = e.currentTarget;
        const productContent = clickedBtn.closest(".trc-product-content");

        // Diğer tüm açık kartları kapat ve stillerini sıfırla
        closeAllCards();

        // Tıklanan kartın "Select Store" butonunu gizle
        clickedBtn.style.display = "none";

        if (productContent) {
          const btnWrapper = productContent.querySelectorAll(".trc-main-col-detail .trc-dd__compat-card");
          btnWrapper.forEach((item) => (item.style.display = "flex"));

          const cardStoreBtns = productContent.querySelectorAll(".store-btn");
          cardStoreBtns.forEach((item) => (item.style.display = "block"));

          // .store-btns-wrapper elemanının top padding değerini 2rem yap
          const storeBtnsWrapper = productContent.querySelector(".store-btns-wrapper");
          if (storeBtnsWrapper) {
            storeBtnsWrapper.style.paddingTop = "2rem";
          }
        }
      });
    });
  });
});